/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';
import classNames from 'classnames';
import { CloseIcon } from 'tdesign-icons-react';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { useMessageClass } from './useMessageClass.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-8c8a3203.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';

function MessageClose(_ref) {
  var closeBtn = _ref.closeBtn,
    onCloseBtnClick = _ref.onCloseBtnClick;
  var _useMessageClass = useMessageClass(),
    tdMessageClassGenerator = _useMessageClass.tdMessageClassGenerator;
  var _useGlobalIcon = useGlobalIcon({
      CloseIcon: CloseIcon
    }),
    CloseIcon$1 = _useGlobalIcon.CloseIcon;
  var relCloseBtn = closeBtn;
  if (typeof closeBtn === "function") {
    relCloseBtn = closeBtn();
  }
  if (!relCloseBtn) {
    return null;
  }
  if (typeof relCloseBtn === "string" || typeof relCloseBtn === "number") {
    return /* @__PURE__ */React.createElement("span", {
      className: tdMessageClassGenerator("close"),
      onClick: function onClick(e) {
        return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    }, closeBtn);
  }
  if ( /*#__PURE__*/React.isValidElement(relCloseBtn)) {
    var _onClick = relCloseBtn.props.onClick;
    return /*#__PURE__*/React.cloneElement(relCloseBtn, {
      className: classNames(relCloseBtn.props.className, tdMessageClassGenerator("close")),
      onClick: function onClick(e) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
        onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    });
  }
  return /* @__PURE__ */React.createElement(CloseIcon$1, {
    className: tdMessageClassGenerator("close"),
    onClick: function onClick(e) {
      return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
        e: e
      });
    }
  });
}

export { MessageClose as default };
//# sourceMappingURL=MessageClose.js.map
